export default "__VITE_ASSET__D89yXw9$__";